import React, { Component } from 'react';
import {
  Button, Card, CardBody, Col, Table, Badge, UncontrolledTooltip, FormGroup,
} from 'reactstrap';
import { withTranslation } from 'react-i18next';
import swal from 'sweetalert';
import ReactPaginate from 'react-paginate';

import UserModal from './UserModal';
import Users from '../../../services/UsersService';
import global from '../../../global';

class UserLists extends Component {
  constructor(props) {
    super(props);
    this.state = {
      realList: [],
      list: [],
      modal: false,
      title: '',
      formdata: {
        name: '',
        username: '',
        password: '',
        location: '',
        type: '',
      },
      errorMsg: '',
    };
    this.isLoading = false;
    this.showPassField = true;
    this.toggleModal = this.toggleModal.bind(this);
    this.addToggle = this.addToggle.bind(this);
    this.addSubmitForm = this.addSubmitForm.bind(this);
    this.userdata = JSON.parse(localStorage.getItem('userData'));
    this.handleClick = this.handleClick.bind(this);
  }

  componentDidMount() {
    this.isLoading = true;
    this.onLoadUsers();
  }

  componentWillUnmount() {
    this.isLoading = false;
  }

  onLoadUsers = async () => {
    try {
      const response = await Users.getUsers(this.userdata.type);
      this.setState({ list: response, realList: response });
      this.handleClick();
    } catch (err) {
      console.log('Error: ', err.message);
    }
    this.isLoading = false;
  }

  handleChange = (e, fieldName) => {
    if (fieldName === 'location') {
      this.setState(prevState => ({
        formdata: { ...prevState.formdata, location: e.value, locationName: e.label },
      }));
    } else if (fieldName === 'locationType') {
      const { name, value } = e.target;
      this.setState(prevState => ({
        formdata: {
          ...prevState.formdata, [name]: value, location: '', locationName: '',
        },
      }));
    } else if (fieldName === 'username') {
      const { name, value } = e.target;
      this.setState(prevState => ({
        formdata: {
          ...prevState.formdata, [name]: value.replace(/\s/g, ''),
        },
      }));
    } else {
      const { name, value } = e.target;
      this.setState(prevState => ({
        formdata: { ...prevState.formdata, [name]: value },
      }));
    }
  }

  updateUserStatus = (e, id, status) => {
    e.preventDefault();
    const statusTxt = status === 1 ? 'activate' : status === 2 ? 'remove' : 'deactivate';

    swal({
      title: 'Confirmation',
      text: `Are you sure you want to ${statusTxt} this user?`,
      icon: 'warning',
      closeOnClickOutside: false,
      buttons: {
        yes: 'YES',
        no: 'NO',
      },
    }).then((name) => {
      name = name.toLowerCase();

      if (name === 'yes') {
        Users.updateUserStatus(id, status).then((result) => {
          if (result === true) {
            this.onLoadUsers();
            swal('', `Successfully ${statusTxt}d user!`, 'success');
          } else {
            swal('', 'Something went wrong!', 'error');
          }
        }).catch((error) => {
          console.log(error);
        });
      }
    });
  }

  addToggle() {
    this.toggleModal('Add');
    this.showPassField = true;
    this.setState({
      formdata: {
        name: '',
        username: '',
        password: '',
        location: '',
        type: '',
      },
    });
    this.handleSubmit = (e) => { this.addSubmitForm(e); };
  }

  addSubmitForm(e) {
    e.preventDefault();
    const { formdata } = this.state;
    const type = parseInt(formdata.type, 10);
    if (formdata.name && formdata.username && formdata.password && formdata.type && (((type !== 1 || type !== 5 || type !== 6) && formdata.location) || (type === 1 || type === 5 || type === 6))) {
      Users.addUser(formdata).then((result) => {
        if (result.msg_resp === true) {
          this.onLoadUsers();
          this.setState({ errorMsg: '', modal: false });

          swal({
            title: 'New User was added!',
            text: 'Would you like to add a new user?',
            icon: 'success',
            closeOnClickOutside: false,
            buttons: {
              no: 'NOPE',
              yes: 'ADD NEW',
            },
          }).then((name) => {
            name = name.toLowerCase();

            if (name === 'yes') {
              this.addToggle();
            }
          });
        } else {
          this.setState({ errorMsg: result.msg_resp });
        }
      }).catch((error) => {
        console.log(error);
      });
    } else {
      this.setState({ errorMsg: 'Required fields are empty.' });
    }
  }

  handleClick(event = '') {
    const selected = event !== '' ? event.selected + 1 : 1;
    const { realList } = this.state;

    const lastPost = selected * 10;
    const firstPost = lastPost - 10;

    const newList = realList.slice(firstPost, lastPost);
    this.setState({ list: newList });
 }

  editToggle(id) {
    this.toggleModal('Edit');
    this.setState({ errorMsg: '' });
    this.showPassField = false;
    // get location info
    Users.getUserInfo(id).then((result) => {
      if (result) {
        this.setState({
          formdata: {
            name: result.name,
            username: result.username,
            location: result.location_id,
            type: result.type,
            locationName: result.location_name,
          },
        });
      }
    }).catch((error) => {
      console.log(error);
    });
    // submit form
    this.handleSubmit = (e) => { this.editSubmitForm(e, id); };
  }

  editSubmitForm(e, userId) {
    e.preventDefault();
    const { formdata } = this.state;
    formdata.userId = userId;

    if (formdata.name && formdata.username && formdata.location !== 0 && formdata.type) {
      Users.editUser(formdata).then((result) => {
        if (result === true) {
          const { list } = this.state;
          list.filter((listResp) => {
            if (listResp.user_id === userId) {
              listResp.name = formdata.name;
              listResp.username = formdata.username;
              listResp.location_name = formdata.locationName;
              listResp.type = formdata.type;
            }
            return listResp;
          });
          this.setState({ list, modal: false });

          swal('', 'Successfully updated user information!', 'success');
        } else {
          this.setState({ errorMsg: result });
        }
      }).catch((error) => {
        console.log(error);
      });
    } else {
      this.setState({ errorMsg: 'Required fields are empty.' });
    }
  }

  toggleModal(text = '') {
    this.setState(prevState => ({ modal: !prevState.modal }));
    if (text) {
      this.setState({ title: text });
    }
  }

  render() {
    const {
      list, modal, title, formdata, errorMsg, realList,
    } = this.state;
    const { userType, statusType } = global;

    return (
      <Col md={12}>
        <UserModal
          title={`${title} User`}
          modal={modal}
          showPassField={this.showPassField}
          toggle={this.toggleModal}
          handleChange={this.handleChange}
          handleSubmit={this.handleSubmit}
          postValue={formdata}
          errorMsg={errorMsg}
        />
        <Card className="panel panel--primary do_magic" id="users_table">
          <CardBody className="panel__body">
            <div className="panel__title bg_blue">
              <h5 className="bold-text">USERS</h5>

              <div className="panel__btns">
                <Button onClick={this.addToggle} className="rounded text-white" size="sm" outline><i className="fa fa-user-plus m-r-4 m-l-3" /> <span>Add User</span></Button>
              </div>
            </div>
            <div className="panel__content">
              <Table responsive striped className="doResTable">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Username</th>
                    <th>Type</th>
                    <th>Location</th>
                    <th width="20%" className="text-center">Status</th>
                    <th width="10%" className="text-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    list !== false || list.length > 0 ? list.map((item, i) => {
                      item.status = parseInt(item.status, 10);
                      let statusColor = 'success';
                      let btnColor = 'danger';
                      let btnIcon = 'times';
                      let statusText = 'Deactivate';
                      if (item.status === 1) {
                        statusColor = 'danger';
                        btnColor = 'success';
                        btnIcon = 'check';
                        statusText = 'Activate';
                      }

                      return (
                        <tr key={item.user_id}>
                          <td>{item.name}</td>
                          <td>{item.username}</td>
                          <td>{userType[item.type]}</td>
                          <td>{item.location_name ? item.location_name : '-'}</td>
                          <td className="text-center"><Badge color={statusColor}>{statusType[item.status]}</Badge></td>
                          <td className="text-center ab">
                            {
                              /* Edit */
                              item.status === 0 && (this.userdata.type === '1' || (this.userdata.type === '5' && item.type !== '1')) && (
                                <>
                                  <Button color="primary" className="btn-xs" onClick={() => this.editToggle(item.user_id)} id={`usereditbtn${i + 1}`} outline><span className="lnr lnr-pencil" /></Button>
                                  <UncontrolledTooltip placement="bottom" target={`usereditbtn${i + 1}`}>Edit</UncontrolledTooltip>
                                </>
                              )
                            }
                            {
                              /* Activate / Deactivate */
                              item.user_id !== this.userdata.user_id && item.type !== '1' ? (
                                <>
                                  <Button color={btnColor} className="btn-xs" onClick={e => this.updateUserStatus(e, item.user_id, item.status)} id={`statusbtn${i + 1}`} outline><span className={`fa fa-${btnIcon}`} /></Button>
                                  <UncontrolledTooltip placement="bottom" target={`statusbtn${i + 1}`}>{statusText}</UncontrolledTooltip>
                                </>
                              ) : ''
                            }
                            {
                              /* Activate / Deactivate */
                              item.user_id !== this.userdata.user_id && item.type !== '1' ? (
                                <>
                                  <Button color="danger" className="btn-xs" onClick={e => this.updateUserStatus(e, item.user_id, 2)} id={`trashbtn${i + 1}`} outline><span className="fa fa-trash" /></Button>
                                  <UncontrolledTooltip placement="bottom" target={`trashbtn${i + 1}`}>Permanent Delete</UncontrolledTooltip>
                                </>
                              ) : ''
                            }
                          </td>
                        </tr>
                      );
                    }) : (
                      <tr className="text-center">
                        <td colSpan="6">No data available..</td>
                      </tr>
                    )
                  }
                </tbody>
              </Table>
              <FormGroup className={list === false || (realList.length / 10) <= 1 ? 'display-none' : ''}>
                <ReactPaginate
                    previousLabel="<<"
                    nextLabel=">>"
                    breakLabel="..."
                    breakClassName="break-me"
                    pageCount={realList.length / 10}
                    onPageChange={this.handleClick}
                    marginPagesDisplayed={0}
                    pageRangeDisplayed={2}
                    containerClassName="list-pagination"
                    activeClassName="active"
                />
              </FormGroup>
            </div>
          </CardBody>
        </Card>
      </Col>
    );
  }
}

export default withTranslation('common')(UserLists);
